const residentEmailPageData = {
  slug: "resident-email",
  title: "RESIDENT Email",
  introduction:
    "Target over 8 million responsive UK consumers through targeted data-driven acquisition campaigns. It's totally audience-defined, privacy-safe, compliant and built to scale.",
  hero: {
    eyebrow: "Data-Driven Acquisition",
    align: "left",
    highlights: [
      { value: "8M+", label: "Responsive UK consumers you can reach" },
    ],
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "what-is-resident-email",
      variant: "feature",
      icon: "mail",
      title: "What is RESIDENT Email?",
      content: [
        "Acquiring customers via paid social and search can be expensive, competitive and ineffective. With RESIDENT Email, you can target responsive UK consumers who are receptive to brand offers and services.",
        "You simply select your audience from our many targeting variables, choose your campaign period, and deploy quickly and efficiently with near-instantaneous results. You can even choose a time of day when your audience is likely to be most receptive based on audience click histories.",
        "With RESIDENT Email, it's easier to find and acquire new customers who look like your most profitable ones with our intelligent audience matching service.",
      ],
    },

    {
      type: "benefits",
      variant: "checklist",
      heading: "Benefits",
      items: [
        { title: "Efficient targeting which reduces campaign costs" },
        { title: "Less competition for attention" },
        { title: "Highly cost-effective" },
        { title: "Target people who look like your top-performing customers" },
        { title: "Deploy quickly and at a time when people are most receptive" },
        { title: "Use your existing email creative assets" },
        { title: "Real-time campaign performance results" },
      ],
    },

    {
      id: "case-study-tiffany",
      title: "Case Study: Tiffany & Co",
      titleDivider: true,
      content: [
        "Tiffany & Co, the luxury jewellery brand, had never before attempted to acquire new customers within the UK via email. They turned to RESIDENT Email for help in time for a Valentine's Day campaign.",
      ],
    },
    {
      id: "campaign-process",
      title: "Campaign Process",
      titleDivider: true,
      content: [
        "Lloyd James was able to run a profile of the Tiffany & Co UK live customer base and identify 'lookalike' consumers within the RESIDENT database.",
        "After identification, Lloyd James provided further targeting and selection of consumers via wealth indicators and advanced propensity algorithms.",
        "Once the audience selection base was ready, attention was turned to the campaign creative, ensuring that it was multi-browser, multi-device compatible and tested for deliverability.",
        "Lloyd James deployed the campaign using highly managed scheduling rules over a tight ten-day period.",
      ],
    },
    {
      id: "campaign-highlights",
      title: "Campaign Highlights",
      titleDivider: true,
      content: [
        "After campaign attribution and match-back, the results you could say were 'love at first sight' and simply stunning!",
      ],
    },
    {
      type: "stats",
      variant: "cards",
      items: [
        { value: "9", suffix: "%", label: "Open Rate" },
        { value: "11", suffix: "%", label: "Click Rate" },
        { value: "2,711", label: "New Customers Acquired" },
        { value: "590,000", prefix: "£", label: "New Sales Generated" },
        { value: "60", suffix: "×", label: "Return on Investment" },
      ],
    },

    {
      id: "cta-highlight",
      variant: "feature",
      icon: "mail",
      title: "Get Started",
      content: ["To find out how we can help you, contact us today!"],
      cta: { label: "Contact us today", href: "#enquiry" },
    },
  ],

  // No fixed pricing model exists for this service.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "RESIDENT Email",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "RESIDENT Email - Lloyd James Data Consultancy",
    description:
      "Reach over 8 million responsive UK consumers with RESIDENT Email — audience-defined, privacy-safe, compliant email acquisition campaigns built to scale.",
    keywords:
      "RESIDENT email, email acquisition, UK consumer targeting, data-driven email marketing, lookalike audience, customer acquisition, Lloyd James",
    canonical: "/resident-email/",
  },
};

export default residentEmailPageData;
